/** Maximum file size for client-side CSV/TSV import (250 MB). The whole file
 *  is held in memory to parse it, and the Arrow form of text-heavy data is
 *  larger than the source; raise this only once the parser streams the file. */
export const MAX_CSV_SIZE = 250 * 1024 * 1024;

/** Maximum file size for client-side Parquet import (200 MB).
 *  Parquet files are compressed; decompressed Arrow data may be 3-5x larger. */
export const MAX_PARQUET_SIZE = 200 * 1024 * 1024;

/** Sample size for CSV sniffing and preview (1 MB). */
export const SAMPLE_SIZE = 1_000_000;
